import UtilizationCRU from "./UtilizationCRU";
import UtilizationList from "./UtilizationList";
import FleetUtilizationList from "./FleetUtilizationList";

export {
    UtilizationCRU,
    UtilizationList,
    FleetUtilizationList
}

export const utilizationObj = {

}


export const rangeValidations = [
    { from: 'hours_from', till: 'hours_till', label: 'Flight Hours' },
    { from: 'cycles_from', till: 'cycles_till', label: 'Flight Cycles' },
    { from: 'tsn_from', till: 'tsn_till', label: 'TSN' },
    { from: 'csn_from', till: 'csn_till', label: 'CSN' }
];

export const utilizationTypeOptions = [
    { label: 'Ferry Flight', value: 'Ferry Flight' },
    { label: 'CTA Entry for Return', value: 'CTA Entry for Return' },
    { label: 'CTA Entry for Delivery', value: 'CTA Entry for Delivery'},
    { label: 'Reporting Utilization', value: 'Reporting Utilization' },
    { label: 'Shop Visit', value: 'Shop Visit' },
    { label: 'Test Flight', value: 'Test Flight' },
];